import { render } from "./SectionRow.vue?vue&type=template&id=71951045"
import script from "./SectionRow.vue?vue&type=script&lang=js"
export * from "./SectionRow.vue?vue&type=script&lang=js"

import "./SectionRow.vue?vue&type=style&index=0&id=71951045&lang=scss"
script.render = render

export default script